/**
 * Status of a ProvisionAgentStatement (Provisionsabrechnung). ACTIVE = the currently valid final
 * statement of an agent and run; SUPERSEDED = replaced by a re-issue (a new version with a new
 * number), the old document stays in dm.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionStatementStatus}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end.
 *
 * Deliberately without `Enum` type-name suffix, like all backend-mirroring enums of this module
 * (see {@link ProvisionRunStatus}).
 */
export enum ProvisionStatementStatus {

    ACTIVE,
    SUPERSEDED
}
